import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import IMG_06 from '../Assets/IMG-35.jpg';
import Footer from "../Components/Footer";
import Landing from "../Components/Landing";
import Courasel from "../Components/Courasel";


function Home(){
    return(
        <>
        <Navbar/>
        <Hero
        cName="hero"

        heroImg={IMG_06}

        title="Multishades insurance"

        text="Protecting What Matters Most to You"

        btnText="Get Started"
        url="/service"
        btnClass="show"
        
        />
        <Landing/>
        <Courasel/>
        <Footer/>
        </>
    )
}
export default Home;